export default (value1, value2) => {
	return typeof value1 !== 'undefined' ? value1 : value2;
}
